<template>
    <NavBar />

    <h3 id="pageHeader">This is the Planet Page</h3>

    <div class="panel">


    </div>
</template>
  
<script>
export default {
    name: "LandingPage",
    components: {
    },
};


</script>
  
<style scoped></style>